var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 510 510",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m388 15.356v387.992c0 7.443-6.033 13.476-13.476 13.476h-346.048c-7.443 0-13.476-6.033-13.476-13.476v-387.992z",
    fill: "#ecba78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.585 15.356h21.415v387.992c0 7.443-6.033 13.476-13.476 13.476h-21.415c7.443 0 13.476-6.033 13.476-13.476z",
    fill: "#e3a76f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m262.355 15.356v149.042c0 3.943-3.196 7.139-7.138 7.139h-107.434c-3.942 0-7.138-3.196-7.138-7.139v-149.042z",
    fill: "#e3a76f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.934 15.356h15.421v149.042c0 3.943-3.196 7.139-7.138 7.139h-15.421c3.942 0 7.138-3.196 7.138-7.139z",
    fill: "#c48958"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m75.147 331.445c-6.304 0-11.422-5.117-11.422-11.421 0-6.303 5.118-11.421 11.422-11.421h102.844c6.304 0 11.422 5.118 11.422 11.421 0 6.304-5.118 11.421-11.422 11.421zm102.844 18.042c6.304 0 11.422 5.118 11.422 11.422 0 6.303-5.118 11.421-11.422 11.421h-102.844c-6.304 0-11.422-5.118-11.422-11.421 0-6.304 5.118-11.422 11.422-11.422z",
    fill: "#eceff1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m398.458 494.644c53.175 0 96.542-12.31 96.542-27.402s-43.367-27.386-96.542-27.386c-53.176 0-96.543 12.294-96.543 27.386s43.367 27.402 96.543 27.402z",
    fill: "#a79ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.958 494.562c49.693-1.092 89.042-12.944 89.042-27.32s-39.349-26.213-89.042-27.304c2.475-.055 4.976-.082 7.5-.082 53.175 0 96.542 12.294 96.542 27.386s-43.367 27.402-96.542 27.402c-2.524 0-5.025-.027-7.5-.082z",
    fill: "#837683"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m402.258 462.789c-.95 1.111-2.338 1.751-3.8 1.75-1.462 0-2.85-.64-3.8-1.751-34.984-40.678-92.743-100.156-92.743-150.301 0-53.307 43.235-96.542 96.543-96.542 53.323 0 96.542 43.235 96.542 96.542 0 50.145-57.744 109.624-92.742 150.302z",
    fill: "#fe646f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.959 216.232c2.474-.19 4.975-.287 7.499-.287 53.323 0 96.542 43.235 96.542 96.542 0 50.145-57.744 109.624-92.742 150.302-.95 1.111-2.338 1.751-3.8 1.75-1.462 0-2.85-.64-3.8-1.751-1.207-1.403-2.441-2.829-3.699-4.276 35.213-40.495 89.041-97.61 89.041-146.025 0-50.784-39.224-92.426-89.041-96.255z",
    fill: "#fd4755"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m398.458 372.345c32.965 0 59.857-26.892 59.857-59.858 0-32.965-26.892-59.841-59.857-59.841-32.966 0-59.842 26.876-59.842 59.841 0 32.966 26.876 59.858 59.842 59.858z",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.458 252.854c-30.641 2.553-54.842 28.351-54.842 59.633s24.201 57.096 54.842 59.65c-1.649.138-3.317.208-5 .208-32.966 0-59.842-26.892-59.842-59.858 0-32.965 26.876-59.841 59.842-59.841 1.683 0 3.351.07 5 .208z",
    fill: "#d1d1d6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryField);
export default __webpack_public_path__ + "static/media/inventory-field.4e05ac61f071fb58d0f2c3c8f6184c44.svg";
export { ForwardRef as ReactComponent };